import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { queryKeys } from "./queryKeys";

interface UseCompileRunsParams {
  page?: number;
  limit?: number;
  userId?: string;
  projectId?: string;
  hasErrors?: string;
}

export const useCompileRuns = (params: UseCompileRunsParams = {}) => {
  return useQuery({
    queryKey: queryKeys.compileRuns(params as Record<string, unknown>),
    queryFn: () => api.getCompileRuns(params),
  });
};

export const useCompileRun = (compileId: string) => {
  return useQuery({
    queryKey: queryKeys.compileRun(compileId),
    queryFn: () => api.getCompileRun(compileId),
    enabled: !!compileId,
  });
};
